// TIP-609 — the white panel every block on this page sits in. Variants pick
// their own padding and top rule in CSS; nothing is passed as a style object,
// so a caller cannot accidentally replace the panel's own styling.
import React from "react";
import "./counterpartyBriefs.css";

const CbPanel = ({ variant, flush, blocked, className = "", children, ...rest }) => {
  const classes = [
    "cb-panel",
    variant && `cb-panel--${variant}`,
    flush && "cb-panel--flush",
    blocked && "is-blocked",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes} {...rest}>
      {children}
    </section>
  );
};

export default CbPanel;
